/** Copy of the Warehouse transfer page (Operations), ported from VentaHub. */
export const warehouseTransfer = {
  title: 'Warehouse transfer',
  description:
    'Move whole boxes between warehouses — each source box’s contents go into a new box in the destination.',
  fromWarehouse: 'From warehouse',
  toWarehouse: 'To warehouse',
  sameWarehouse: 'The source and destination warehouses must differ.',
  needWarehouses: 'Choose both warehouses.',
  noLines: 'Add at least one box mapping.',
  badLine: 'Line {{line}} needs a box in each warehouse.',
  columns: {
    fromBox: 'From box',
    toBox: 'To box',
  },
  actions: {
    validate: 'Validate',
    transfer: 'Transfer',
  },
  boxes_one: '{{count}} box',
  boxes_other: '{{count}} boxes',
  units_one: '{{count}} unit',
  units_other: '{{count}} units',
  wouldMove: 'Would move {{boxes}} · {{units}}',
  moved: 'Moved {{boxes}} · {{units}}',
  result: {
    columns: {
      fromBox: 'From box',
      toBox: 'To box',
      units: 'Units',
      skuCount: 'SKUs',
      status: 'Status',
    },
    canMove: 'Can move',
    empty: 'No boxes.',
    cannotMove: 'Cannot move everything: fix the lines marked below.',
  },
} as const
